export class TimelineModule {
    constructor() {
        if ($("#component-timeline").length > 0) {
            this.properties();
            this.init();
        }
    }

    properties() {
        this.timelineSlider = $("#component-timeline .timeline__slider");
        this.timelineSlickArrow = $("#component-timeline .slick-arrow");
        this.timelineRange = $("#component-timeline .timeline__range");
        // this.slidesToShow = 3.2;
        // this.slidesToScroll = 1;
    }

    loadSlick() {
        /* if the browser width is greater than the breakpoint it will render */
        /* this is how slick gets the width var windowWidth = window.innerWidth || $(window).width(). This includes the scroll bar */

        let _this = this;
        this.timelineSlider.slick({
            //   dots: false,
            //   infinite: false,
            //   slidesToShow: 1.1,
            //   slidesToScroll: 1,
            //   arrows: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 0,
                    settings: {
                        dots: false,
                        infinite: false,
                        slidesToShow: 1.1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: false,
                        infinite: false,
                        slidesToShow: 2.2,
                        slidesToScroll: 2,
                        arrows: false
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        dots: false,
                        infinite: false,
                        slidesToShow: 3.2,
                        slidesToScroll: 1,
                        arrows: false
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        dots: false,
                        infinite: false,
                        slidesToShow: 3.2,
                        slidesToScroll: 1,
                        arrows: true
                    }
                }
            ]
        });
    }

    /* checks if slick is disable, if so changes the gradient */
    updateGradientIfSlickIsDisabled() {

        setTimeout(() => {

            if ($("#component-timeline .slick-prev").hasClass('slick-disabled')) {
                $("#component-timeline .timeline__gradient--left").fadeOut();
            } else {
                $("#component-timeline .timeline__gradient--left").fadeIn();
            }

            if ($("#component-timeline .slick-next").hasClass('slick-disabled')) {
                $("#component-timeline .timeline__gradient--right").fadeOut();
            } else {
                $("#component-timeline .timeline__gradient--right").fadeIn();
            }

        }, 200);
    }

    calcRangeIndexToSlickIndex(rangeIndex) {
        return rangeIndex;
    }

    /* get index of range */
    getRangeIndex() {
        return this.timelineRange.val();
    }
    /* set index of range */
    setRangeIndex(index) {

        return this.timelineRange.val(index);
    }
    /* change range by index */
    moveSliderByIndex(index) {
        this.timelineSlider.slick('slickGoTo', index);
        //  $(".timeline__slider").slick('slickGoTo', index);
    }
    /* get slick index */
    getSlickIndex() {
        return $("#component-timeline .slick-active").data("slick-index");
    }
    /* change range on change event */
    bindRangeChange() {
        if (this.rangeSliderIsHidden()) {
            return;
        }

        let _this = this;
        this.timelineRange.on('change', function () {
            let rangeIndex = $(this).val();
            let newSlickIndex = _this.calcRangeIndexToSlickIndex(rangeIndex);
            _this.moveSliderByIndex(newSlickIndex);
            _this.updateGradientIfSlickIsDisabled();
        });
    }
    /* moves below carousel and list view */
    bindToggleTimelineView() {
        var _this = this;
        $(document).on('click', '#component-timeline .button__full-timeline-toggle', function (event) {
            event.preventDefault();
            let listStyle = _this.timelineSlider.data('list-style');
            if (listStyle === 'carousel') {
                $('#component-timeline .wrapper-timeline--carousel').hide();
                $('#component-timeline .wrapper-timeline--list').show();
                _this.timelineSlider.data('list-style', 'list');
                $(".button__full-timeline-toggle--carousel").hide();
                $(".button__full-timeline-toggle--list").show();
            } else {
                $('#component-timeline .wrapper-timeline--carousel').show();
                $('#component-timeline .wrapper-timeline--list').hide();
                _this.timelineSlider.data('list-style', 'carousel');
                //    $("#component-timeline .timeline__range-container").show();
                $(".button__full-timeline-toggle--carousel").show();
                $(".button__full-timeline-toggle--list").hide();
            }
        });
    }
    /* bind arrow click */
    bindSlickArrowClick() {
        let _this = this;
        if (this.rangeSliderIsHidden()) {
            return;
        }
        $(document).on('click', "#component-timeline .slick-arrow", function () {

            _this.updateGradientIfSlickIsDisabled();
            let slickIndex = _this.getSlickIndex();
            _this.moveSliderByIndex(slickIndex);
            _this.setRangeIndex(slickIndex);
        });

    }
    /* bind browser resize to reload click */
    bindResize() {
        let _this = this;
        var resizeTimeout;

        $(window).on("resize.treatmentTimeline", function () {
            //  console.log("timeline 2");
            $("#component-timeline .timeline__slider").slick('slickGoTo', 0);
            //   $("#component-timeline .timeline__slider").slick('unslick');
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                _this.equalHeights();
            }, 500);
        });
    }

    unbindResize() {
        $(window).off("resize.treatmentTimeline");
        // If we wanted to be purist, also remove the slick instance from the carousel element
    }
        
    /* bind slick swipe */
    bindSlickSwipe() {
        let _this = this;


        $(document).on('swipe', '#component-timeline .timeline__slider', function () {

            if (!_this.rangeSliderIsHidden()) {
                let slickIndex = _this.getSlickIndex();
                _this.setRangeIndex(slickIndex);
            }

            _this.updateGradientIfSlickIsDisabled();

        });
    }
    /* equal heights */
    equalHeights() {

        $(".timeline__slider").each(function () {
            var highestBox = 0;

            $(".timeline__item", this).each(function () {
                if ($(this).height() > highestBox) {
                    highestBox = $(this).height();
                }
            });

            $('.timeline__item').height(highestBox);
            $('.timeline__gradient--left').height(highestBox + 20);
            $('.timeline__gradient--right').height(highestBox + 20);

        });

    }

    rangeSliderIsHidden() {
        return $(".wrapper-range").is(":hidden");
    }

    init() {

        if ($("#component-timeline").length === 0) return;
        this.loadSlick();
        this.bindRangeChange();
        this.bindSlickArrowClick();
        this.bindSlickSwipe();

        // Carousel mode
        if ($(".button__full-timeline-toggle--bulletedlist").is(":hidden")) {

            this.bindToggleTimelineView();
            this.bindResize();
            $("#component-timeline .timeline__loading").hide();
            this.equalHeights();
        }
        // Bulleted list mode
        else {
            this.bindInteractiveView();

            $("#component-timeline .timeline__loading").hide();

            $(".button__full-timeline-toggle--carousel").hide();
            $(".button__full-timeline-toggle--list").hide();
            $('#component-timeline .wrapper-timeline--carousel').hide();
            $('#component-timeline .wrapper-timeline--bulletedlist').show();

            this.ShowTimeLineViewAsBulletedList();
            this.ShowTimeLineViewAsList();
        }
    }

    // This will be triggered when clicking view interactive timeline button
    bindInteractiveView() {
        let that = this;
        $(document).on('click', '.button__full-timeline-toggle--bulletedlist', function (e) {
            e.preventDefault();

            $(".button__full-timeline-toggle--carousel").show();
            $('.wrapper-timeline--carousel').show();

            $('.wrapper-timeline--bulletedlist').hide();
            $(".button__full-timeline-toggle--bulletedlist").hide();
            $(".button__full-timeline-toggle--list").hide();
            $('.wrapper-timeline--list').hide();            

            // Bind resize, then trigger a fake resize event.
            that.bindResize();
            $(document).trigger("resize");        
        });
    }

    //Triggered When clicking on viewfull timeline button
    ShowTimeLineViewAsList() {
        let that = this;
        $(document).on('click', '.button__full-timeline-toggle--carousel', function (e) {
            e.preventDefault();
            that.unbindResize();

            $('.wrapper-timeline--bulletedlist').hide();
            $(".button__full-timeline-toggle--bulletedlist").hide();

            $('.wrapper-timeline--carousel').hide();
            $('.wrapper-timeline--list').show();
            $(".button__full-timeline-toggle--list").show();
            $(".button__full-timeline-toggle--carousel").hide();
            // Unbind slick
            // Pseudo code - $(document).off("resize")

        });

    }

    //Triggered When clicking on close button
    ShowTimeLineViewAsBulletedList() {
        let that = this;
        $(document).on('click', '.button__full-timeline-toggle--list', function (e) {
            e.preventDefault();
            that.unbindResize();

            // Displays the data in bulleted list format
            $('.wrapper-timeline--bulletedlist').show();
            $(".button__full-timeline-toggle--bulletedlist").show();

            $('.wrapper-timeline--carousel').hide();
            $('.wrapper-timeline--list').hide();
            $(".button__full-timeline-toggle--carousel").hide();
            $(".button__full-timeline-toggle--list").hide();
        });
    }
}

